(function (global) {
    "use strict";

    function initAutoMarquees(defaultSlice = 2) {
        document.querySelectorAll(".dhn-marquee").forEach((wrap) => {
            const tracks = wrap.querySelectorAll(".dhn-marquee-content");
            if (!tracks.length) return;

            // Get slice value per wrap or use default
            const slice = parseFloat(wrap.dataset.slice) || defaultSlice;

            // Optional gap override
            const gap = wrap.dataset.gap;

            tracks.forEach((track) => {
                const items = track.querySelectorAll(".dhn-marquee-item").length || 1;
                const duration = `${items * slice}s`;

                // Set CSS variable and animation duration
                wrap.style.setProperty("--marquee-speed", duration);
                track.style.animationDuration = duration;

                if (gap) {
                    wrap.style.setProperty("--marquee-gap", gap);
                    track.style.gap = gap;
                }

                console.log(`[marquee] ${items} items × ${slice}s → ${duration}`);
            });
        });
    }



    /* boot once */
    if (document.readyState !== "loading") {
        initAutoMarquees();
    } else {
        global.addEventListener("DOMContentLoaded", () => initAutoMarquees());
    }

    /* expose for list updates after AJAX, etc. */
    global.initAutoMarquees = initAutoMarquees;
})(window);
